import React from 'react';
import { FacebookIcon, InstagramIcon, LockIcon } from 'lucide-react';
const CONTACT_EMAIL = 'contactmetodikaplus@gmail.com';
export function Footer() {
  return <footer className="bg-white px-5 py-8 sm:px-8" data-id="element-35" data-mp="3ghc0pwojutll">
      <div className="mx-auto w-full max-w-content border-t border-line pt-8 text-center" data-id="element-36" data-mp="32ovwwtntqrjm">
        <p className="font-display text-[17px] font-bold uppercase text-ink" data-id="element-37" data-mp="36ooa5jo5xlvb">
          Libres de Ser © 2026
        </p>
        <p className="mt-1 font-sans text-[14px] uppercase tracking-[0.06em] text-ink-soft" data-id="element-38" data-mp="3ugbrb9vmhike">
          Producido por Metodika+
        </p>

        <nav aria-label="Redes sociales" className="mt-5 flex items-center justify-center gap-3" data-id="element-39" data-mp="36czunggsbik">
          <a href="#facebook" aria-label="Facebook" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-coral transition-colors duration-150 ease-out hover:border-coral hover:bg-coral-soft/50" data-id="element-40" data-mp="3lgosmvua2qv1">
            <FacebookIcon aria-hidden="true" className="h-5 w-5" data-id="element-41" data-mp="2eyjrbpg1x6w7" />
          </a>
          <a href="#instagram" aria-label="Instagram" className="flex h-11 w-11 items-center justify-center rounded-full border border-line text-coral transition-colors duration-150 ease-out hover:border-coral hover:bg-coral-soft/50" data-id="element-42" data-mp="3l9ac9f9lwy2u">
            <InstagramIcon aria-hidden="true" className="h-5 w-5" data-id="element-43" data-mp="3v8hqs5s2uyrj" />
          </a>
        </nav>

        <p className="mt-6 font-sans text-[13px] uppercase tracking-[0.06em] text-muted" data-id="element-44" data-mp="3q7llpovzp6kj">
          Contacto:
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="mt-1 inline-block break-all font-sans text-[14px] text-ink-soft underline decoration-line underline-offset-4 transition-colors duration-150 ease-out hover:text-coral" data-id="element-45" data-mp="817b9zwxjeqw">
          {CONTACT_EMAIL}
        </a>

        <p className="mt-6 font-sans text-[13px] uppercase tracking-[0.06em] text-ink-soft" data-id="element-46" data-mp="ctgvr0f9zmls">
          Respaldado por Avanza Pro LLC Company
        </p>

        <p className="mt-4 flex items-center justify-center gap-2 font-sans text-[13px] text-muted" data-id="element-47" data-mp="qrf6lvue10wj">
          <LockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-48" data-mp="mq3g7o3owbna" />
          Plataforma segura · Pago 100% protegido
        </p>
      </div>
    </footer>;
}